import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft, Cookie } from 'lucide-react';

export default function CookiePolicyPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="border-b bg-white sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-6 py-4 flex items-center gap-4">
          <Button variant="ghost" onClick={() => navigate(-1)} className="rounded-full">
            <ArrowLeft className="w-5 h-5" />
          </Button>
          <div className="flex items-center gap-2">
            <Cookie className="w-5 h-5 text-emerald-600" />
            <h1 className="font-heading text-lg font-semibold">Cookie-policy</h1>
          </div>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-8 prose prose-slate">
        <p className="text-muted-foreground">Senast uppdaterad: Mars 2026</p>

        <h2>1. Vad är cookies?</h2>
        <p>
          Cookies är små textfiler som sparas på din enhet när du besöker en webbplats. 
          De används för att webbplatsen ska fungera korrekt och för att förbättra din upplevelse.
        </p>

        <h2>2. Vilka cookies använder Livon?</h2>
        
        <h3>Nödvändiga cookies</h3>
        <p>Dessa cookies krävs för att Tjänsten ska fungera:</p>
        <table className="w-full text-sm">
          <thead>
            <tr>
              <th className="text-left">Cookie</th>
              <th className="text-left">Syfte</th>
              <th className="text-left">Varaktighet</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><code>token</code></td>
              <td>Håller dig inloggad</td>
              <td>7 dagar</td>
            </tr>
            <tr>
              <td><code>refresh_token</code></td>
              <td>Förnyar din session</td>
              <td>30 dagar</td>
            </tr>
            <tr>
              <td><code>session_id</code></td>
              <td>Identifierar din session</td>
              <td>Session</td>
            </tr>
          </tbody>
        </table>

        <h3>Funktionella cookies</h3>
        <p>Dessa cookies förbättrar din upplevelse:</p>
        <table className="w-full text-sm">
          <thead>
            <tr>
              <th className="text-left">Cookie</th>
              <th className="text-left">Syfte</th>
              <th className="text-left">Varaktighet</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><code>theme</code></td>
              <td>Sparar ditt val av ljust/mörkt tema</td>
              <td>1 år</td>
            </tr>
            <tr>
              <td><code>onboarding-completed</code></td>
              <td>Visar att du sett introduktionen</td>
              <td>Permanent</td>
            </tr>
          </tbody>
        </table>

        <h2>3. Tredjepartscookies</h2>
        <p>Vi använder följande tredjepartstjänster som kan sätta egna cookies:</p>
        <ul>
          <li><strong>Stripe:</strong> För säker betalningshantering</li>
        </ul>
        <p>
          Vi använder INTE cookies för reklam eller spårning över olika webbplatser.
        </p>

        <h2>4. Hantera cookies</h2>
        <p>
          Du kan hantera cookies i din webbläsares inställningar. Observera att om du 
          blockerar nödvändiga cookies kan du inte logga in eller använda Tjänsten.
        </p>
        <p>Så här hanterar du cookies i vanliga webbläsare:</p>
        <ul>
          <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer">Google Chrome</a></li>
          <li><a href="https://support.mozilla.org/sv/kb/aktivera-och-inaktivera-cookies" target="_blank" rel="noopener noreferrer">Firefox</a></li>
          <li><a href="https://support.apple.com/sv-se/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer">Safari</a></li>
          <li><a href="https://support.microsoft.com/sv-se/microsoft-edge/ta-bort-cookies-i-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09" target="_blank" rel="noopener noreferrer">Microsoft Edge</a></li>
        </ul>

        <h2>5. Ändringar</h2>
        <p>
          Vi kan uppdatera denna policy. Ändringar publiceras på denna sida med nytt datum.
        </p>

        <h2>6. Kontakt</h2>
        <p>
          Har du frågor om vår användning av cookies?<br />
          E-post: support@livon.se
        </p>

        <div className="mt-8 p-4 bg-amber-50 rounded-xl border border-amber-200">
          <p className="text-sm text-amber-800 m-0">
            <strong>Sammanfattning:</strong> Vi använder endast nödvändiga cookies för att 
            Tjänsten ska fungera. Vi spårar dig inte för reklam.
          </p>
        </div>
      </main>
    </div>
  );
}
